// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"_d883121","iframe":"_c48d9fd"};